
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useSSE.html",
      function () {
        return require("private-next-pages/Hooks/useSSE.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useSSE.html"])
      });
    }
  